import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../../context/GlobalContext";
import { updateContactInfo } from '../../api/api';

class MobileNumUpdate extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      userType: "",
      profileFirstName: '',
      profileMobileNumber: '',
      firstName: '',
      mobileNumber: '',
      isFirstNameUpdated: false,
      isContactInfoUpdated: false,
      errors: {},
      lang: ''
    }
  }

  componentDidMount = () => {
    const [context] = this.context;
    const { personalInfo, contactInfo } = context.profileEnquiryResult

    this.setState({
      lang: context.lang,
      userType: context.userType,
      profileFirstName: personalInfo?.firstName,
      profileMobileNumber: contactInfo?.mobileNumber.replace("+", ""),
      firstName: personalInfo?.firstName,
      mobileNumber: contactInfo?.mobileNumber.replace("+", ""),
    })
  }

  onFocus = (event) => event.target.setAttribute("autocomplete", "off");

  handleFirstNameChange = (event) => {
    const { profileFirstName } = this.state;
    const firstName = event.target.value
    this.setState({
      firstName,
      isFirstNameUpdated: profileFirstName !== firstName
    })
  }

  handleMobileNumChange = (event) => {
    const { profileMobileNumber } = this.state
    const mobileNumber = event.target.value
    this.setState({
      mobileNumber,
      isContactInfoUpdated: profileMobileNumber !== mobileNumber
    })
  }

  validateForm() {
    let errors = {};
    let formIsValid = true;
    const { firstName, mobileNumber } = this.state

    if (!firstName) {
      formIsValid = false;
      errors["profileName"] = "username_required"
    }
    if (!mobileNumber) {
      formIsValid = false;
      errors["profileMobileNumber"] = "mobile_number_required"
    }
    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleMobileNumberSubmit = async (event) => {
    event.preventDefault()
    if (this.validateForm()) {
      const { lang, firstName, mobileNumber, isFirstNameUpdated, isContactInfoUpdated } = this.state
      const reGen = /^[9]{1}[6]{1}[6]{1}[0-9]{9,12}$/;
      const reCust = /^[0]{1}[5]{1}[0-9]{8}$/;
      const [context, dispatch] = this.context;
      const changeInDetailsFlag = isContactInfoUpdated || isFirstNameUpdated
      let errors = {};

      if (reGen.test(mobileNumber) || reCust.test(mobileNumber)) {
        const mobileNumUpdateResponse = changeInDetailsFlag ? await updateContactInfo(mobileNumber, firstName, true) : {}
        const { data } = mobileNumUpdateResponse
        if (isContactInfoUpdated) {
          if (data?.status.code === "MAPI-000") {
            dispatch({
              type: 'UPDATE_MOBILE_NUM',
              payload: {
                otpType: "Mobile",
                mobileNum: mobileNumber,
                hashCode: data.hashCode
              }
            })
            dispatch({
              type: 'GO_TO_SCREEN',
              payload: { profileUpdateScreen: "ActivationCodeScreen" }
            })
          }
          else {
            errors["customError"] = lang === "ar" ? data?.status.arabicDetail : data?.status.englishDetail
            this.setState({
              errors: errors,
            });
          }
        }
        else {
          dispatch({
            type: 'UPDATE_STEP_VALUE',
            payload: { stepVal: "two" }
          })
          dispatch({
            type: 'GO_TO_SCREEN',
            payload: { profileUpdateScreen: "EmailAndCityUpdate" }
          })
        }
      }
      else {
        errors["customError"] = "invalid_mobilenumber"
        this.setState({
          errors: errors,
        });
      }
    }
  }

  render() {
    const { t } = this.props;
    const { userType, errors, isContactInfoUpdated, firstName, mobileNumber } = this.state
    return (
      <div>
        <div className="pu_subheading">{t("filldetails_text")}</div>

        {errors.customError ? (
          <div className="alert alert-danger" role="alert">
            <b>
              {t(errors.customError)}{" "}
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </b>
          </div>
        ) : null}

        {!userType && <div className={
          "profile-update " + "form-group " + (errors.profileName ? "not-valid" : "")}>
          <label className="pu-input-label">{t("first_name")}</label>
          <input
            type="text"
            screen="MobileUpdateScreen"
            className="form-control pu-input-field"
            placeholder={t("enter_your_name")}
            value={firstName}
            onChange={this.handleFirstNameChange}
            maxLength="50"
            onFocus={this.onFocus} />

          {this.state.errors.profileName ? (
            <div className="alert alert-danger" role="alert">
              {t(this.state.errors.profileName)}{" "}
              <i
                className="fa fa-exclamation-circle"
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>}

        <div className={
          "profile-update " + "form-group " +
          (errors.profileMobileNumber ? "not-valid" : "")
        }
        >
          <label className="pu-input-label">{t("usermobile")}</label>
          <input
            type="text"
            className="form-control pu-input-field"
            placeholder={t("enter_your_mobilenumber")}
            value={mobileNumber}
            onChange={this.handleMobileNumChange}
            maxLength="50"
            onFocus={this.onFocus} />

          {this.state.errors.profileMobileNumber ? (
            <div className="alert alert-danger" role="alert">
              {t(this.state.errors.profileMobileNumber)}{" "}
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>


        <button id="mobileUpdateButton" onClick={this.handleMobileNumberSubmit}
          type="submit"
          name="mobile_update_button"
          className="btn min_outlin_btn active pu-button">
          {t("update")}{" "}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </button><br />

        {isContactInfoUpdated && <p>{t("verification_code_text")}</p>}
      </div>
    )
  }
}

export default withTranslation()(MobileNumUpdate);